import { requestBjh } from '@/utils/request'

/**
 * 北京号搜索
 */
export const getBjhSearchArticlsList = params => {
  return requestBjh({
    method: 'GET',
    // url: `/rest/site/api/bjrbbeijinghao/story/list?app=1&keywords=${params.keywords}&pageNumber=${params.pageNum}&pageSize=10`
    url: `/api/site/bjrbbeijinghao/story/search/list?app=1&keywords=${params.keywords}&pageNumber=${params.pageNum}&pageSize=10`
  })
}
